var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm.nextUpcomingOutage && _vm.shouldShowOutageBanner ? _c('div', {
    staticClass: "the_outage_callout"
  }, [_c('Alert', {
    staticClass: "outage_alert mb-0 mt-0",
    staticStyle: {
      "margin-bottom": "0 !important"
    },
    attrs: {
      "dismissible": !_vm.isNextOutageWithinThreeHours,
      "type": _vm.outageAlertState
    },
    on: {
      "input": _vm.closeAlert
    }
  }, [_c('div', {
    staticClass: "c-grid"
  }, [_c('div', {
    staticClass: "col-full outage_timeframe",
    class: {
      outage_error: _vm.outageAlertState === _vm.AlertType.ERROR,
      outage_info: _vm.outageAlertState === _vm.AlertType.INFO,
      outage_warning: _vm.outageAlertState === _vm.AlertType.WARNING
    },
    staticStyle: {
      "border-right": "2px solid rgba(255, 255, 255, 0.25)"
    }
  }, [_vm.shouldShowCountdown ? _c('span', {
    staticClass: "display-1 monospace_font"
  }, [_vm._v(_vm._s(_vm.timeUntilNextUpcomingOutageStarts))]) : _vm._e(), _vm.isOutageInProgress ? _c('p', {
    staticClass: "mb-0 subheading"
  }, [_c('strong', [_vm._v("Outage in progress")])]) : _c('p', {
    staticClass: "mb-0 subheading"
  }, [_c('strong', [_vm._v("Outage Scheduled")])]), _c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "line-height": "2em"
    }
  }, [_vm._v(" There will be an outage from "), _c('span', {
    staticClass: "text-no-wrap"
  }, [_c('span', {
    staticClass: "monospace_font font-weight-bold outage_range_value",
    staticStyle: {
      "background": "white",
      "border-radius": "4px",
      "padding": "2px 4px",
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm.nextUpcomingOutageStart))]), _vm._v(" to "), _c('span', {
    staticClass: "monospace_font font-weight-bold outage_range_value",
    staticStyle: {
      "background": "white",
      "border-radius": "4px",
      "padding": "2px 4px",
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm.nextUpcomingOutageEnd))])])])]), _c('div', {
    staticClass: "col-full outage_user_facing_message",
    domProps: {
      "innerHTML": _vm._s(_vm.nextUpcomingOutageWarningText)
    }
  })])])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };